import { MappedAEMProperties } from '../../../../types';
import ArticleItem from '../../base/Article/Article';
import styles from './ArticleList.module.scss';
import Layout from '../../../common/Layout/Layout';
import { Article } from '../../../common/model';
import { CY_ARTICLE_ATTRIBUTES } from '../../../../lib/constants/cypress';

export type ArticleListProps = {
  heading?: string;
  articles?: Article[];
} & MappedAEMProperties;

const ArticleList = ({ heading, articles }: ArticleListProps) => (
  <div className={styles.articlesWrapper} data-cy={CY_ARTICLE_ATTRIBUTES.CONTAINER}>
    <Layout>
      <div className={styles.articlesGrid}>
        {heading ? <h2 className={styles.heading}>{heading}</h2> : null}
        {(articles || []).map(article => (
          <ArticleItem key={article.id} {...article} />
        ))}
      </div>
    </Layout>
  </div>
);

export default ArticleList;
